export const ECOLOGI_LINKEDIN_URL = 'https://www.linkedin.com/company/ecologihq';
export const ECOLOGI_INSTAGRAM_URL = 'https://instagram.com/ecologi_hq';
export const ECOLOGI_X_URL = 'https://x.com/Ecologi_hq';
export const ECOLOGI_YOUTUBE_URL = 'https://www.youtube.com/channel/UCKUr5skdKV-GL6bV_-krprg';

export * from './project-assets';
export * from './phoenix-config-assets';

export const PLATFORM_DOMAIN = 'ecologi.com';

const PR_STAGE_REGEX = /^pr-?(\d+)$/;

function getPrNumber(stageName: string): string | null {
  const match = stageName.match(PR_STAGE_REGEX);
  return match ? match[1] : null;
}

export function getWebClientBaseUrl(stageName?: string) {
  if (stageName === 'staging') return `https://x.${PLATFORM_DOMAIN}`;
  if (stageName === 'qa') return `https://qa.${PLATFORM_DOMAIN}`;
  if (stageName === 'production') return `https://${PLATFORM_DOMAIN}`;
  if (stageName) {
    const prNumber = getPrNumber(stageName);
    if (prNumber !== null) return `https://pr${prNumber}.${PLATFORM_DOMAIN}`;
  }
  return 'http://localhost:3000';
}

export function getBaseApiUrl(stageName?: string) {
  if (stageName === 'staging') return `https://x.api.${PLATFORM_DOMAIN}`;
  if (stageName === 'production') return `https://api.${PLATFORM_DOMAIN}`;
  if (stageName === 'qa') return `https://qa.api.${PLATFORM_DOMAIN}`;
  if (stageName) {
    const prNumber = getPrNumber(stageName);
    if (prNumber !== null) return `https://pr-${prNumber}.api.${PLATFORM_DOMAIN}`;
  }
  return 'http://localhost:5000';
}

export function getBaseApiV2Url(fallbackUrl: string): string {
  const isLocalDev = new URL(fallbackUrl).hostname === 'localhost';
  return isLocalDev ? 'http://localhost:5001' : fallbackUrl;
}

export function getPhoenixUrl(stageName?: string) {
  if (stageName === 'staging') return `https://x.app.${PLATFORM_DOMAIN}`;
  if (stageName === 'production') return `https://app.${PLATFORM_DOMAIN}`;
  if (stageName === 'qa') return `https://qa.app.${PLATFORM_DOMAIN}`;
  if (stageName && getPrNumber(stageName) !== null) {
    return `https://qa.app.${PLATFORM_DOMAIN}`;
  }
  return 'http://localhost:3001';
}

export const getPublicProfilePath = (userIdentifier: string): string => `/profile/${userIdentifier}`;

export const getPublicProfileUrl = (
  baseUrl: string,
  userIdentifier: string,
  searchParams?: Record<string, string>,
): string => {
  const profileUrl = `${baseUrl}${getPublicProfilePath(userIdentifier)}`;

  return searchParams ? `${profileUrl}?${new URLSearchParams(searchParams)}` : profileUrl;
};
